import { Button as LyfeButton, Typography } from "@lyfegen-platform/react-common";
import { Box, Dialog, DialogActions, IconButton, makeStyles } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

export interface IText {
	continue: string | JSX.Element;
	discard?: string;
	question?: string | Array<string>;
	reason?: string | Array<string>;
	error?: string | Array<string>;
	utility?: string;
}

interface IProps {
	isOpen: boolean;
	onContinueClick: (e: any) => any;
	onDiscardClick?: (e: any) => any;
	onUtilityClick?: () => any;
	isSaveEnabled?: boolean;
	text: IText;
	children?: any;
	dialogActionStyles?: any;
	isFixedWidth?: boolean;
}

const useStyles = makeStyles((theme) => ({
	paper: {
		borderRadius: theme.spacing(2),
		padding: theme.spacing(2),
		minWidth: "584px",
		minHeight: "285px",
	},
	paperNewUi: {
		borderRadius: "0.25rem",
		minWidth: "454px",
		minHeight: "185px",
		boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.08)",
	},
}));

export default function ModalDialog(props: IProps) {
	const classes = useStyles({});
	const { t } = useTranslation();

	return (
		<Dialog
			open={props.isOpen}
			onClose={props.onDiscardClick}
			maxWidth="lg"
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			PaperProps={{
				className: classes.paperNewUi,
				style: props.isFixedWidth ? { width: "480px", bottom: "112px" } : {},
			}}
			BackdropProps={{ invisible: true }}
			style={{ backgroundColor: "rgba(28, 49, 69, 0.4)" }}
		>
			<Box width="100%" display="flex" justifyContent="flex-end">
				<IconButton onClick={props.onDiscardClick} style={{ color: "#5e6e7d" }}>
					<CloseIcon />
				</IconButton>
			</Box>
			{props.children ? (
				<Box width="100%" height="100%" alignContent="center">
					{props.children}
				</Box>
			) : (
				<Box py={2} px={5}>
					{Array.isArray(props.text.question)
						? props.text.question.map((question) => (
								<Typography align="left" type="semi-bold" variant="subtitle2" style={{ fontSize: "18px" }}>
									{t(question)}
								</Typography>
						  ))
						: props.text.question && (
								<Typography align="left" type="semi-bold" variant="subtitle2" style={{ fontSize: "18px" }}>
									{t(props.text.question)}
								</Typography>
						  )}
					&nbsp; &nbsp;
					{Array.isArray(props.text.reason)
						? props.text.reason.map((reason, i) => (
								<Typography
									align="left"
									type="fieldText"
									variant="subtitle2"
									style={{
										fontSize: "14px",
										fontWeight: 400,
										marginBottom: i === props.text.reason!.length - 1 ? "0px" : "24px",
									}}
								>
									{t(reason)}
								</Typography>
						  ))
						: props.text.reason && (
								<Typography align="left" type="fieldText" variant="subtitle2" style={{ fontSize: "14px", fontWeight: 400 }}>
									{t(props.text.reason)}
								</Typography>
						  )}
					{Array.isArray(props.text.error)
						? props.text.error.map((error, i) => (
								<Typography
									align="left"
									type="fieldText"
									variant="subtitle2"
									style={{
										fontSize: "14px",
										fontWeight: 400,
										marginBottom: i === props.text.error!.length - 1 ? "0px" : "24px",
									}}
								>
									{t(error)}
								</Typography>
						  ))
						: props.text.error && (
								<Typography align="left" type="fieldText" variant="subtitle2" style={{ fontSize: "14px", fontWeight: 400 }}>
									{t(props.text.error)}
								</Typography>
						  )}
				</Box>
			)}

			<DialogActions style={{ ...props.dialogActionStyles }}>
				<Box display="flex" justifyContent="space-between" p={2}>
					{props.text.utility && props.onUtilityClick && (
						<LyfeButton variant="text" onClick={props.onUtilityClick} color="primary">
							{t(props.text.utility).toLocaleUpperCase()}
						</LyfeButton>
					)}
					{props.text.discard && (
						<LyfeButton
							style={{ marginRight: "32px", marginLeft: "32px" }}
							variant="outlined"
							onClick={props.onDiscardClick}
							color="primary"
						>
							{t(props.text.discard).toLocaleUpperCase()}
						</LyfeButton>
					)}
					<LyfeButton
						variant="contained"
						onClick={props.onContinueClick}
						autoFocus
						color="primary"
						disabled={props.isSaveEnabled === false}
					>
						{typeof props.text.continue === "string" ? t(props.text.continue).toLocaleUpperCase() : props.text.continue}
					</LyfeButton>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
